import { Nullable } from 'types';

export const parseJSON = <T>(json: any): Nullable<T> => {
  try {
    return JSON.parse(json as string) as T;
  } catch {
    return null;
  }
};
